interface InitialAvatarProps {
  readonly name: string;
  readonly className?: string;
}

export function InitialAvatar({ name, className = 'size-9 text-sm' }: InitialAvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-ink font-medium text-paper ${className}`}
    >
      {name.trim().charAt(0).toUpperCase() || '?'}
    </span>
  );
}
